import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../../utils/axios';
import handleRequestError from '../../utils/handleRequestError';

const initialState = {
    isLoading: true,
    ftFuelTanks: [],
    ftFuelTankById: {},
    ftFuelTankOperationsById: [],
    error: '',
};

export const fetchFTFuelTanks = createAsyncThunk(
    'ftFuelTanks/fetchFTFuelTanks',
    async (params, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_HOST_API_KEY}/fueltank`, {
                params,
            });

            return response.data;
        } catch (err) {
            return handleRequestError(err, rejectWithValue);
        }
    }
);

export const deleteFTFuelTanks = createAsyncThunk(
    'ftFuelTanks/deleteFTFuelTanks',
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.delete(`${process.env.REACT_APP_HOST_API_KEY}/fueltank`, {
                data,
            });

            return response.data;
        } catch (err) {
            return handleRequestError(err, rejectWithValue);
        }
    }
);

export const createFTFuelTanks = createAsyncThunk(
    'ftFuelTanks/createFTFuelTanks',
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${process.env.REACT_APP_HOST_API_KEY}/fueltank`, data);

            return response.data;
        } catch (err) {
            return handleRequestError(err, rejectWithValue);
        }
    }
);

export const fetchFTFuelTankById = createAsyncThunk(
    'ftFuelTanks/fetchFTFuelTankById',
    async (id, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_HOST_API_KEY}/fueltank/${id}`);

            return response.data.data;
        } catch (err) {
            return handleRequestError(err, rejectWithValue);
        }
    }
);

export const fetchFTFuelTankOperationsById = createAsyncThunk(
    'ftFuelTanks/fetchFTFuelTankOperationsById',
    async (id, { rejectWithValue }) => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_HOST_API_KEY}/fueltankoperation/recent-operations?fueltankid=${id}`
            );

            return response.data.data;
        } catch (err) {
            return handleRequestError(err, rejectWithValue);
        }
    }
);

export const updateFTFuelTanks = createAsyncThunk(
    'ftFuelTanks/updateFTFuelTanks',
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.put(`${process.env.REACT_APP_HOST_API_KEY}/fueltank`, data);

            return response.data;
        } catch (err) {
            return handleRequestError(err, rejectWithValue);
        }
    }
);

const ftFuelTanksSlice = createSlice({
    name: 'ftFuelTanksSlice',
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder.addCase(fetchFTFuelTanks.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(fetchFTFuelTanks.fulfilled, (state, { payload }) => {
            state.isLoading = false;
            state.error = '';
            state.ftFuelTanks = payload.data;
        });
        builder.addCase(fetchFTFuelTanks.rejected, (state, action) => {
            state.error = action.payload;
            state.isLoading = false;
        });
        builder.addCase(deleteFTFuelTanks.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(deleteFTFuelTanks.fulfilled, (state) => {
            state.isLoading = false;
            state.error = '';
        });
        builder.addCase(deleteFTFuelTanks.rejected, (state, action) => {
            state.error = action.payload;
            state.isLoading = false;
        });
        builder.addCase(createFTFuelTanks.fulfilled, (state) => {
            state.isLoading = false;
            state.error = '';
        });
        builder.addCase(createFTFuelTanks.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(createFTFuelTanks.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        });
        builder.addCase(fetchFTFuelTankById.fulfilled, (state, { payload }) => {
            state.isLoading = false;
            state.ftFuelTankById = payload;
            state.error = '';
        });
        builder.addCase(fetchFTFuelTankById.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(fetchFTFuelTankById.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        });
        builder.addCase(fetchFTFuelTankOperationsById.fulfilled, (state, { payload }) => {
            state.isLoading = false;
            state.ftFuelTankOperationsById = payload;
            state.error = '';
        });
        builder.addCase(fetchFTFuelTankOperationsById.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(fetchFTFuelTankOperationsById.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        });
        builder.addCase(updateFTFuelTanks.fulfilled, (state) => {
            state.isLoading = false;
            state.error = '';
        });
        builder.addCase(updateFTFuelTanks.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(updateFTFuelTanks.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        });
    },
});

export default ftFuelTanksSlice.reducer;

export const selectFTFuelTanksData = (state) => state.ftFuelTanks.ftFuelTanks;
export const selectFTFuelTankById = (state) => state.ftFuelTanks.ftFuelTankById;
export const selectFTFuelTankOperationsById = (state) => state.ftFuelTanks.ftFuelTankOperationsById;
export const selectFTFuelTanksLoading = (state) => state.ftFuelTanks.isLoading;
export const selectFTFuelTanksError = (state) => state.ftFuelTanks.error;
